import { VuzRecommendationTab } from 'portfolio3/features/vuzRecommendation/const';

import { FavoritesEventPayload, UniversityCardСlickName, YandexMetrikaRecomendationsTabNames } from '../types/shapes';

export type RecommendationEvents =
  | TabsRecommendationsSwitchEvent
  | RecommendationSearchEvent
  | RecommendationSortingEvent
  | FavoritesAddingEvent
  | FavoritesDeletionEvent
  | FavoritesRecommendationEvent
  | UniversityDetailsEvent
  | RecommendationPagesSwitchEvent
  | RecommendationApi
  | OpenServiceRecommendationsEvent
  | RecomendationSearchFieldTouchedEvent
  | RecommendationsFilterMoreOrCollapseEvent
  | RecommendationsResetFiltersClickEvent
  | RecommendationsUniversityCardСlickEvent
  | RecommendationsUniversityCardDetailsLinkClickEvent
  | RecommendationsUniversityCardDetailsBounceEvent;

export const VuzRecommendationTabToEventName = {
  [VuzRecommendationTab.REAL_GIA]: 'basedOnFinalExam',
  [VuzRecommendationTab.TRIAL_GIA]: 'basedOnTrialExam',
  [VuzRecommendationTab.SUBJECTS]: 'basedOnSubject',
  [VuzRecommendationTab.FAVORITES]: 'favourite',
} as const;

/**
 * Запрос апи мос.ру aisearch/vuz_frontapi, раздел рекомендации
 */
type RecommendationApi = {
  type: 'recommendationApi';
  payload: {
    // название реферала с которого идет обращение
    url: string;
  };
};

/**
 * Успешное переключение между вкладками в рекомендации вузов
 * По результатам итогового ЕГЭ, По результатам пробного ЕГЭ и т.д.
 */
type TabsRecommendationsSwitchEvent = {
  type: 'tabsRecommendationsSwitch';
  payload: {
    resultsChoice: YandexMetrikaRecomendationsTabNames;
  };
};

/**
 * Ввел условия поиска рекомендаций и нажал кнопку "Начать поиск"
 * Клиентская фильтрация результатов, нужно отправлять метрику когда устанавливаем стейт (потенциально)
 */
type RecommendationSearchEvent = {
  type: 'recommendationSearch';
  payload: {
    filters: {
      subjects?: number[];
      specialities?: number[];
      typeStudy?: string;
      militaryTraining?: string;
      passingScore: {
        minScore?: number;
        maxScore?: number;
      };
      recommendationsHigherScore: 'on' | 'off';
    };
    // поисковый запрос, который вводит пользователь
    wordsSearch?: string;
    // число результатов поиска
    resultWordSearch: number;
    resultsChoice: YandexMetrikaRecomendationsTabNames;
  };
};

/**
 * Успешный выбор сортировки рекомендаций
 */
type RecommendationSortingEvent = {
  type: 'recommendationSorting';
  payload: {
    // тип сортировки, который выбрал пользователь
    sortType: string;
    resultsChoice: YandexMetrikaRecomendationsTabNames;
  };
};

/**
 * Успешное добавление рекомендации в Избранное
 */
type FavoritesAddingEvent = {
  type: 'favoritesAdding';
  payload: FavoritesEventPayload;
};

/**
 * Успешное удаление рекомендации из Избранного
 */
type FavoritesDeletionEvent = {
  type: 'favoritesDeletion';
  payload: FavoritesEventPayload;
};

/**
 * Переключение на вкладку Избранное в Рекомендациях
 */
type FavoritesRecommendationEvent = {
  type: 'favoritesRecommendation';
};

/**
 * Нажатие на кнопку Подробнее о вузе и открытие сайд-бара
 */
type UniversityDetailsEvent = {
  type: 'universityDetails';
};

/**
 * Переключения между страницами с выдачей Рекомендаций
 */
type RecommendationPagesSwitchEvent = {
  type: 'recommendationPagesSwitch';
  payload: {
    // максимальный номер страницы, на которую переключался пользователь в этот визит
    maxPage: number;
  };
};

/**
 * Открытие раздела Выбор вуза
 */
type OpenServiceRecommendationsEvent = {
  type: 'open_service_recommendations_click';
};

/**
 * Активация поисковой строки и ввод хотя бы одного символа
 */
type RecomendationSearchFieldTouchedEvent = {
  type: 'recommendations_search_click';
};

/**
 * Клик по кнопке Свернуть фильтры или Еще фильтры
 */
type RecommendationsFilterMoreOrCollapseEvent = {
  type: 'recommendations_filterMoreOrCollapse';
  payload: {
    resultsChoice: YandexMetrikaRecomendationsTabNames;
    actionType: 'filterMore' | 'filterCollapse';
  };
};

/**
 * Клик по активной кнопке Сбросить все
 */
type RecommendationsResetFiltersClickEvent = {
  type: 'recommendations_reset_filters_click';
  payload: {
    resultsChoice: YandexMetrikaRecomendationsTabNames;
  };
};

/**
 * Клик по кнопкам (Название вуза, ссылка на сайт вуза,
 * кнопка Показать еще или кнопка Подробнее) в карточке вуза на странице поиска
 */
type RecommendationsUniversityCardСlickEvent = {
  type: 'recommendations_universityCard_click';
  payload: {
    buttonName: UniversityCardСlickName;
    resultsChoice: YandexMetrikaRecomendationsTabNames;
    universityName: string;
    searchPlacement: number;
  };
};

/**
 * Клик по ссылке на сайт вуза в карточке вуза (Подробнее)
 */
type RecommendationsUniversityCardDetailsLinkClickEvent = {
  type: 'recommendations_universityCard_details_link_click';
  payload: {
    resultsChoice: YandexMetrikaRecomendationsTabNames;
    universityName: string;
    searchPlacement: number;
  };
};

/**
 * Закрытие карточки вуза в течение 15 секунд послее ее открытия
 */
type RecommendationsUniversityCardDetailsBounceEvent = {
  type: 'recommendations_universityCard_details_bounce';
  payload: {
    resultsChoice: YandexMetrikaRecomendationsTabNames;
    universityName: string;
    searchPlacement: number;
  };
};
